import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'
import { CHROME_RADIUS, TOUCH_MIN } from 'core/theme.tokens'

interface ConfirmDialogProps {
  open: boolean
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  onConfirm: () => void
  onCancel: () => void
  severity?: 'info' | 'warning' | 'error'
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
  severity = 'warning',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth='xs'
      fullWidth
      fullScreen={false}
      PaperProps={{
        sx: { borderRadius: `${CHROME_RADIUS}px`, overflow: 'hidden' },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant='body2' color='text.secondary'>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ flexDirection: { xs: 'column-reverse', sm: 'row' }, alignItems: 'stretch' }}>
        <Button onClick={onCancel} color='inherit' sx={{ minHeight: TOUCH_MIN }}>
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant='contained'
          color={severity === 'error' ? 'error' : 'primary'}
          autoFocus
          sx={{ minHeight: TOUCH_MIN }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
